module.exports = __webpack_public_path__ + "img/KITCHEN_UTENSIL_AMENITY.5ed2826f.svg";